module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/skate-icon-6a2d06cb090231d4c3e0efe9986557c7.svg";